import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'itl-desktop-detail-view-header-button',
  templateUrl: './desktop-detail-view-header-button.component.html',
  styleUrls: ['./desktop-detail-view-header-button.component.scss'],
  standalone: false,
})
export class DesktopDetailViewHeaderButtonComponent {
  @Output() clicked: EventEmitter<null> = new EventEmitter<null>();
}
